import React, { useState, useEffect, useRef, useCallback } from "react";
import "../css/allPatient.css";
import { SEARCH_ICON, cufrontIcons } from "../../cufront-assets/icons/Icons";
import GridLayout from "../layouts/GridLayout";
import TableLayout from "../layouts/TableLayout";
import { useItemsFilterNew } from "../../_helper/actions/app/items";
import { useAtom } from "jotai";
import {
  allPatientDataAtom,
  clinicAtom,
  selectedDoctorAtom,
} from "../../_helper/constant/constant-atom";
import { useCurrentRole } from "../../_helper/constant/Permission";
import PaginationComponent from "../../common_component/component/PaginationComponent";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { AiOutlineUserAdd } from "react-icons/ai";
import CuSpinner from "../../common_component/component/CuSpinner";
import { GiHamburgerMenu } from "react-icons/gi";
import { TfiLayoutGrid3Alt } from "react-icons/tfi";
import CuScreenLoader from "../../common_component/component/CuScreenLoader";
import AddUserModal from "../components/AddUserModal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { secureAxios } from "../../_helper/constant/auth";
import { toast } from "react-toastify";
import { RxCross2 } from "react-icons/rx";
import { useMediaQuery } from "react-responsive";
import Popup from "../../common_component/component/Popup";

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

const AllPatient = () => {
  const [allPatientData, setAllPatientData] = useAtom(allPatientDataAtom);
  const [selectedDoctor, setSelectedDoctor] = useAtom(selectedDoctorAtom);
  const [isGrid, setIsGrid] = useState(allPatientData.isGrid || true);
  const [currentPage, setCurrentPage] = useState(
    allPatientData.currentPage || 1
  );
  const [searchData, setSearchData] = useState(allPatientData.searchData || "");
  const [isSearching, setIsSearching] = useState(false);
  const [clinic] = useAtom(clinicAtom);
  const [isAddUser, setIsAddUser] = useState({ flag: false, type: "" });
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const allClinic = searchParams.get("all_clinic");
  const [perPageLimit, setPerPageLimit] = useState(
    allPatientData.perPageLimit || 15
  );
  const { role_id } = useCurrentRole();
  const [downloadLimit, setDownloadLimit] = useState("");
  const [downloading, setDownloading] = useState(false);
  const [customLimit, setCustomLimit] = useState(false);
  const [data, setData] = useState(allPatientData.data || []);
  const observer = useRef();
  const [hasMore, setHasMore] = useState(true);
  const [allData, setAllData] = useState(allPatientData.allData || []);
  const [totalPages, setTotalPages] = useState(allPatientData.totalPages || 1);
  const sm = useMediaQuery({ query: "(max-width:635px)" });

  const toggleLayout = () => {
    setIsGrid(!isGrid);
  };

  // console.log("selectedDoctor", selectedDoctor);

  const debouncedSearchData = useDebounce(searchData, 500);

  const clinicIds = allClinic === "true" ? "" : `&clinic_ids=${clinic?.id}`;

  const filter = `?action=getDoctorPatients&backend=True&clinic_id=${clinic?.id}&doctor_id=${selectedDoctor ? selectedDoctor : role_id}&records_number=${perPageLimit}&page=${currentPage}&member_name=${debouncedSearchData}${clinicIds}`;

  const { data: response, isLoading } = useItemsFilterNew(
    ApiEndPoint.USERS,
    filter,
    clinic && role_id ? true : false,
    null
  );

  // useEffect(() => {
  //   // Reset all relevant state variables
  //   setCurrentPage(1);
  //   setSearchData("");
  //   setPerPageLimit(15);
  //   setData([]);
  //   setAllData([]);
  //   setTotalPages(1);
  //   setIsGrid(true);
  //   setDownloadLimit("");
  //   setHasMore(true);
  // }, [clinic?.id, allClinic, role_id]);

  useEffect(() => {
    if (response) {
      setData(response);
      setAllData((prevAllData) => {
        const newData =
          response.data?.filter(
            (newItem) => !prevAllData.some((item) => item.id === newItem.id)
          ) || [];
        return [...prevAllData, ...newData];
      });
      setHasMore(response.data?.length > 0);
      setTotalPages(Math.ceil(response.data_count / perPageLimit) || 1);
    }
  }, [response, clinic?.id, allClinic, role_id]);

  const lastDataElementRef = useCallback(
    (node) => {
      if (isLoading || currentPage >= totalPages) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoading, hasMore, currentPage, totalPages]
  );

  useEffect(() => {
    setAllPatientData({
      isGrid,
      currentPage,
      searchData,
      perPageLimit,
      allData: allData,
      totalPages,
      scrollPosition: window.scrollY,
    });
  }, [
    isGrid,
    currentPage,
    searchData,
    perPageLimit,
    allData,
    data,
    totalPages,
  ]);

  useEffect(() => {
    const savedScrollPosition = allPatientData.scrollPosition;
    if (savedScrollPosition) {
      window.scrollTo(0, parseInt(savedScrollPosition));
    }
  }, [allPatientData.scrollPosition]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleGoToPage = (event) => {
    const page = parseInt(event.target.value);
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleGoToPage(event);
    }
  };

  const handleInputChange = (e) => {
    setSearchData(e.target.value);
    setIsSearching(e.target.value.trim() !== "");
    setCurrentPage(1);
    setAllData([]);
  };

  const handleAddPatient = (type) => {
    navigate(`/new/registration?type=${type}`);

    // setIsAddUser({ flag: true, type });
  };

  const handleAllClinic = (checked) => {
    navigate(`/new/all-patient?all_clinic=${checked}`);
  };

  const downloadFilter = `?action=getDownloadPatient&backend=True&clinic_id=${clinic?.id}&fields=id,email,full_name,gender,phone,allergy&doctor_id=${role_id}&clinic_ids=${clinic?.id}&limit=${downloadLimit}`;

  function convertToCSV(data) {
    const header = Object.keys(data[0]).join(",");
    const rows = data.map((obj) => Object.values(obj).join(","));
    return `${header}\n${rows.join("\n")}`;
  }

  const handleDownload = async () => {
    if (!downloadLimit) {
      toast.error("Select Limit");
      return;
    }
    try {
      setDownloading(true);
      const response = await secureAxios.get(
        `${ApiEndPoint.CLINIC}${downloadFilter}`
      );
      const data = response?.data;

      const csvData = convertToCSV(data);

      const blob = new Blob([csvData], { type: "text/csv" });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", "patients.csv");
      setDownloading(false);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      setDownloading(false);
      toast.error(error.message);
      console.error("Error downloading data", error);
    }
  };

  const handleCustomLimit = (e) => {
    const val = e.target.value;
    if (val > data?.data_count) {
      setDownloadLimit(data?.data_count);
    } else if (val < 1) {
      setDownloadLimit(1);
    } else {
      setDownloadLimit(e.target.value);
    }
  };

  const handlePatientDetails = (id) => {
    if (sm) {
      navigate(`/new/patient-options?all_clinic=${allClinic}&userId=${id}`);
    } else {
      navigate(
        `/new/patient-options?option=profile&all_clinic=${allClinic}&userId=${id}`
      );
    }
  };

  return (
    <>
      <div className="cu-all-patient-main px-4 sm:py-6">
        <div
          className={`cu-all-patient-heading flex ${
            sm ? "flex-col gap-4" : ""
          } justify-between my-2 mb-3 pb-1 md:border-b md:border-[#00000033]`}
        >
          <span>All Patients ({data?.data_count})</span>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 font-normal text-sm">
              {customLimit ? (
                <div className="flex items-center gap-2">
                  <input
                    type="number"
                    min="1"
                    value={downloadLimit}
                    className="border rounded outline-none px-4 py-1"
                    placeholder="Enter custom limit"
                    onChange={(e) => handleCustomLimit(e)}
                  />
                  <RxCross2
                    size={15}
                    onClick={() => (
                      setCustomLimit(false), setDownloadLimit("")
                    )}
                    className="cursor-pointer"
                  />
                </div>
              ) : (
                <select
                  className="border rounded outline-none px-4 py-1 cursor-pointer"
                  onChange={(e) => {
                    if (e.target.value === "custom") {
                      setCustomLimit(true);
                      setDownloadLimit(""); // Reset the download limit when custom is selected
                    } else {
                      setCustomLimit(false);
                      setDownloadLimit(e.target.value);
                    }
                  }}
                >
                  <option value="">Select Limit</option>
                  <option value={data?.data_count}>All Patients</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={40}>40</option>
                  <option value={50}>50</option>
                  <option value="custom">Custom</option>
                </select>
              )}

              <button
                className="border px-2 rounded py-1 text-sm"
                onClick={handleDownload}
              >
                {downloading ? "Downloading..." : "Download"}
              </button>
            </div>
            <div className="font-normal flex item-center gap-2">
              <label className="relative cursor-pointer">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={allClinic === "true"}
                  onChange={(e) =>
                    handleAllClinic(e.target.checked ? "true" : "false")
                  }
                />
                <div
                  className={`w-11 h-6 flex items-center bg-gray-300 rounded-full peer ${
                    allClinic === "true"
                      ? "peer-checked:after:translate-x-full"
                      : ""
                  } after:absolute after:left-[2px] peer-checked:after:border-white after:bg-white after:border after:border-gray-300 after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#C7EAC9]`}
                ></div>
              </label>
              <span>All</span>
            </div>
          </div>
        </div>
        <div className="cu-search-filter-cont h-16 md:h-24">
          <div className="cu-input-search-filter-div my-4 md:w-[327.7px] lg:h-[28.44px] xl:w-[409.63px] xl:h-[35.56px] 2xl:w-[437.16px] 2xl:h-[37.94px] xlarge:w-[614.44px] xlarge:h-[53.33px]">
            <input
              type="search"
              placeholder="Search by Name"
              onChange={handleInputChange}
              value={searchData}
            />
            {isLoading && isSearching ? (
              <CuSpinner />
            ) : (
              <img className="all-p-search-icon" src={SEARCH_ICON} alt="" />
            )}
            <div className="cu-all-filter">
              <img
                className="all-p-search-icon"
                src={cufrontIcons.filter}
                alt=""
              />
            </div>
          </div>
          <div className="cu-grid-line-icon-div hidden md:flex">
            <div
              className={`w-8 h-8 rounded cursor-pointer ${
                isGrid ? "bg-[#C7EAC9]" : "bg-white"
              } bg-[#C7EAC9] flex justify-center items-center`}
              onClick={toggleLayout}
            >
              <TfiLayoutGrid3Alt size={20} />
            </div>
            <div
              className={`w-8 h-8 rounded cursor-pointer ${
                !isGrid ? "bg-[#C7EAC9]" : "bg-white"
              } bg-[#C7EAC9] flex justify-center items-center`}
              onClick={toggleLayout}
            >
              <GiHamburgerMenu size={25} />
            </div>
            <div className="w-8 h-8 rounded">
              <Popup
                trigger={<AiOutlineUserAdd size={25} />}
                content={
                  <div className="w-[150px] text-center">
                    <div
                      className="cursor-pointer"
                      onClick={() => handleAddPatient("normal")}
                    >
                      Add Patient
                    </div>
                    <div
                      className="cursor-pointer"
                      onClick={() => handleAddPatient("institution")}
                    >
                      Add Institution Patient
                    </div>
                  </div>
                }
                position="left"
              />
            </div>
          </div>
        </div>
        <div className="cu-all-patient-cont min-h-fit md:min-h-[65vh]">
          {isLoading && !isSearching && !sm ? (
            <CuScreenLoader />
          ) : (
            <>
              {isGrid ? (
                <GridLayout
                  data={sm ? allData : response?.data}
                  handlePatientDetails={handlePatientDetails}
                  lastDataElementRef={sm ? lastDataElementRef : null}
                />
              ) : (
                <TableLayout
                  data={sm ? allData : data?.data}
                  handlePatientDetails={handlePatientDetails}
                  lastDataElementRef={sm ? lastDataElementRef : null}
                />
              )}
              {isLoading && sm && !isSearching && (
                <div className="w-full flex justify-center items-center">
                  {currentPage === 1 ? <CuScreenLoader /> : <CuSpinner />}
                </div>
              )}
            </>
          )}
        </div>

        {!sm && (
          <div className="sm:mb-20">
            {!isLoading && (
              <PaginationComponent
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                handleKeyPress={handleKeyPress}
                perPageLimit={perPageLimit}
                setPerPageLimit={setPerPageLimit}
              />
            )}
          </div>
        )}
      </div>
      {isAddUser?.flag && (
        <AddUserModal
          type={isAddUser?.type}
          closeModal={() => setIsAddUser({ flag: false, type: "" })}
        />
      )}
    </>
  );
};

export default AllPatient;
